import { configureStore } from '@reduxjs/toolkit';
import rootReducers from './reducers';
import builderMiddleware from './middlewares/builder';

export const makeStore = (preloadedState: any) => {
  return configureStore({
    reducer: rootReducers,
    // Once we're are reusing our old redux setup (such as actions, reducers)
    // instead of the modern redux toolkit "slice" approach, we need to disable
    // "immutableCheck" otherwise it will raise the error below:
    // Error: Invariant failed: A state mutation was detected between dispatches, in the path '...'
    // this is why we are using the middleware below
    middleware: (getDefaultMiddleware) =>
      getDefaultMiddleware({
        immutableCheck: false,
      }).concat(builderMiddleware),
    preloadedState: {
      ...preloadedState,
      builder: {
        flatOutline: { ...preloadedState?.builder?.flatOutline },
        builderLoaded: true,
        selected: '1-Page',
        editor: {
          open: true,
          tab: 1,
          width: 350,
          height: 460,
          dock: 'right',
          mobileExperienceView: '',
          showAllMediaViewPorts:
            preloadedState?.builder?.editor?.showAllMediaViewPorts,
        },
        pageMap: {
          open: true,
          width: 350,
          height: 460,
          dock: 'left',
        },
        badges: {},
        watchQueryParams: false,
        alwaysRenderInBuilder: [],
        sorting: {},
        version: '',
        dynamicGrid: {
          marketplaceOffers: {
            ...preloadedState?.builder?.dynamicGrid?.marketplaceOffers,
          },
          pressReleases: preloadedState?.builder?.dynamicGrid?.pressReleases,
          activeElementId: null,
        },
      },
      identity: { ...preloadedState.identity },
      loading: {},
      impressions: { preventPageviewReset: false },
    },
  });
};

// Infer the type of makeStore
export type AppStore = ReturnType<typeof makeStore>;
// Infer the `RootState` and `AppDispatch` types from the store itself
export type RootState = ReturnType<AppStore['getState']>;
export type AppDispatch = AppStore['dispatch'];
